import { Component, Input, OnInit } from "@angular/core";
import { AppointmentStatus } from "@app/core/interfaces";

@Component({
    templateUrl: './appointment-status.component.html',
    styleUrls: ['./appointment-status.component.css'],
    selector: 'appointment-status'
})
export class AppointmentStatusComponent implements OnInit {
    @Input() public status: AppointmentStatus;
    statusText: string;
    statusClass: string;
    constructor() {

    }

    ngOnInit(): void {
        switch (this.status) {
            case AppointmentStatus.Confirmed:
                this.statusText = "confirmed"
                this.statusClass = "status success"
                break;
            case AppointmentStatus.Pending:
                this.statusText = "pending",
                this.statusClass = "status warning"
                break;
            case AppointmentStatus.Canceled:
                this.statusText = "canceled",
                this.statusClass = "status danger"
                break;
        }
    }
}